export default {
  data() {
    return {
      filterDateTypeConst: [
        {label: 'Check-in', value: 'checkin'},
        {label: 'Check-out', value: 'checkout'},
        {label: 'Création', value: 'created'},
      ],
    };
  },
};
